module.exports = __webpack_public_path__ + "img/australia-neoplasm-male.6e58693b.png";